import * as moment from 'moment';
import { CALENDAR_LOCALE } from '../../services/constant';
import { ApiService } from '../../services/api.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from '../../services/authentication.service';
var ManageRequestComponent = (function () {
    function ManageRequestComponent(apiService, authService, modalService) {
        this.apiService = apiService;
        this.authService = authService;
        this.modalService = modalService;
        this.calendarLocale = CALENDAR_LOCALE.TH;
        this.itemsPerPage = 40;
        this.loading = false;
        this.startDate = null;
        this.endDate = null;
        this.statusChoices = [
            { label: 'ทั้งหมด', value: null },
            { label: 'รอดำเนินการ', value: 'pending' },
            { label: 'อนุมัติ', value: 'approved' },
            { label: 'ปฏิเสธ', value: 'rejected' },
        ];
        this.requestTypes = [
            { label: 'ทั้งหมด', value: null },
            { label: 'ขอลบเอกสาร', value: 'delete_document' },
            { label: 'ขอแก้ไขเอกสาร', value: 'edit_document' },
        ];
        this.submitting = false;
    }
    ManageRequestComponent.prototype.ngOnInit = function () {
        this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate() - 30);
        this.endDate = new Date();
        this.search();
    };
    Object.defineProperty(ManageRequestComponent.prototype, "yearRange", {
        get: function () {
            var thisYear = new Date().getFullYear();
            return thisYear - 40 + ':' + thisYear;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ManageRequestComponent.prototype, "dateRange", {
        get: function () {
            if (!this.startDate && !this.endDate) {
                return null;
            }
            var start = this.startDate ? moment(this.startDate).format('DD/MM/YYYY') : '';
            var end = this.endDate ? moment(this.endDate).format('DD/MM/YYYY') : '';
            return start + ' - ' + end;
        },
        enumerable: true,
        configurable: true
    });
    ManageRequestComponent.prototype.setMinDate = function () {
        this.minDate = this.startDate;
    };
    ManageRequestComponent.prototype.setMaxDate = function () {
        this.maxDate = this.endDate;
    };
    Object.defineProperty(ManageRequestComponent.prototype, "isSystemAdmin", {
        get: function () {
            return this.authService.isSystemAdmin() || this.authService.isAdmin();
        },
        enumerable: true,
        configurable: true
    });
    ManageRequestComponent.prototype.stopPropagation = function (event) {
        event.stopPropagation();
    };
    ManageRequestComponent.prototype.search = function (resetPageNUmber) {
        var _this = this;
        if (resetPageNUmber === void 0) { resetPageNUmber = true; }
        if (resetPageNUmber) {
            this.currentPage = 1;
        }
        this.loading = true;
        var params = {
            page: this.currentPage,
            page_size: this.itemsPerPage,
            invoice_number: this.invoiceNumber || '',
            request_no: this.requestNo || '',
            request_date_after: moment(this.startDate).format('YYYY-MM-DD'),
            request_date_before: moment(this.endDate).format('YYYY-MM-DD'),
            request_type: this.requestType || '',
            request_user: this.requestUser || '',
            status: this.status || '',
        };
        this.apiService.getDocumentRequests(null, params).subscribe(function (response) {
            _this.tableData = response.results;
            _this.totalItems = response.count;
            _this.loading = false;
        }, function (error) {
            _this.loading = false;
        });
    };
    ManageRequestComponent.prototype.pageChanged = function () {
        this.search(false);
    };
    ManageRequestComponent.prototype.optionChanged = function () {
        this.search();
    };
    ManageRequestComponent.prototype.clearSearch = function () {
        this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate() - 30);
        this.endDate = new Date();
        this.invoiceNumber = null;
        this.requestNo = null;
        this.requestUser = null;
        this.requestType = null;
        this.status = null;
    };
    ManageRequestComponent.prototype.openModal = function (contentModal, data, size) {
        this.selectedRequest = data;
        var modalOptions = {
            centered: true,
            backdrop: 'static'
        };
        if (size) {
            modalOptions.size = size;
        }
        this.modal = this.modalService.open(contentModal, modalOptions);
    };
    ManageRequestComponent.prototype.reject = function () {
        var _this = this;
        if (!this.reason || !this.selectedRequest) {
            return;
        }
        this.submitting = true;
        this.apiService.rejectDocumentRequest(this.selectedRequest.id, { reason: this.reason }).subscribe(function () {
            _this.resultMessage = 'ดำเนินการสำเร็จ';
            _this.modal.close();
            _this.modal = _this.modalService.open(_this.resultModal, { centered: true, backdrop: 'static' });
        }, function (error) {
            _this.resultMessage = 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง';
            _this.modal.close();
            _this.modal = _this.modalService.open(_this.resultModal, { centered: true, backdrop: 'static' });
        });
    };
    ManageRequestComponent.prototype.approve = function () {
        var _this = this;
        if (!this.selectedRequest) {
            return;
        }
        this.apiService.approveDocumentRequest(this.selectedRequest.id).subscribe(function () {
            _this.resultMessage = 'ดำเนินการสำเร็จ';
            _this.modal.close();
            _this.modal = _this.modalService.open(_this.resultModal, { centered: true, backdrop: 'static' });
        }, function (error) {
            _this.resultMessage = 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง';
            _this.modal.close();
            _this.modal = _this.modalService.open(_this.resultModal, { centered: true, backdrop: 'static' });
        });
    };
    ManageRequestComponent.prototype.closeModal = function (search) {
        if (search === void 0) { search = false; }
        this.modal.close();
        this.submitting = false;
        this.reason = null;
        this.resultMessage = null;
        this.selectedRequest = undefined;
        if (search) {
            this.search(false);
        }
    };
    return ManageRequestComponent;
}());
export { ManageRequestComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/manage-request/manage-request.component.ts.pre-build-optimizer.js